import Transfers from './Transfers';

export enum MasterItemCode {
	CAREER_TYPE_CONTROL = 'CAREER_TYPE_CONTROL',
	USE_JINJI_ZOKUSEI = 'USE_JINJI_ZOKUSEI',
	MULTI_TENANT_MODE = 'MULTI_TENANT_MODE',
	QM_APPLICATION_CHECK_NUMBER = 'QM_APPLICATION_CHECK_NUMBER',
	QM_CAREER_NUMBER = 'QM_CAREER_NUMBER',
}

// システムマスタデータ検索処理
export const fetchSystemMst = (
	mstItemCd: MasterItemCode,
	multiSearch: any,
	token: string
) => {
	const param = {
		mstItemCd,
		multiSearch,
	};
	Transfers.read('tsq_common_systemConstantModel', token, param)
		.then(response => response.json())
		.then(receiveData => receiveData.tsq_common_systemConstantModel)
		.then(data => {
			if (data && data.mstList) {
				localStorage.setItem(mstItemCd, data.mstList[0].cdStringValue);
			}
		})
		.catch(e => {
			return;
		});
};

// システムマスタ取得
export const getSystemMst = (mstItemCd: MasterItemCode): string | null => {
	return localStorage[mstItemCd];
};

// システムマスタ取得
export const isValid = (mstItemCd: MasterItemCode): boolean => {
	const value = localStorage[mstItemCd];
	return value && value === '1' ? true : false;
};



// WEBPACK FOOTER //
// ./src/utils/MasterData.ts